import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

import {
    Modal,
    Form,
    Input,
    Button,
    Space,
    Spin
} from "antd";

import {
    ApartmentOutlined
} from "@ant-design/icons";

import api from "../../api/api";

const DivisionFormModal = ({
    open,
    handleClose,
    onDivisionCreated
}) => {

    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!open) {
            form.resetFields();
            setLoading(false);
        }
    }, [open, form]);

    const handleSubmit = async (values) => {

        setLoading(true);

        try {

            const response = await api.post("/api/users/divisions/", {
                name: values.name
            });

            if (response.status === 201) {

                Swal.fire({
                    icon: "success",
                    title: "Department Created",
                    text: "The department has been added successfully.",
                    timer: 1800,
                    showConfirmButton: false
                });

                form.resetFields();

                onDivisionCreated?.();

                handleClose();
            }

        } catch (error) {

            Swal.fire({
                icon: "error",
                title: "Creation Failed",
                text:
                    error.response?.data?.name?.[0] ||
                    error.response?.data?.detail ||
                    "Unable to create department."
            });

        } finally {

            setLoading(false);

        }

    };

    return (

        <Modal
            title={
                <Space>
                    <ApartmentOutlined />
                    Create New Department
                </Space>
            }
            open={open}
            onCancel={handleClose}
            footer={null}
            centered
            width={450}
            destroyOnClose
        >

            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >

                <Form.Item
                    label="Department Name"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: "Please enter a department name."
                        }
                    ]}
                >

                    <Input
                        size="large"
                        prefix={<ApartmentOutlined />}
                        placeholder="Ex. Department of Leadership & Management"
                        disabled={loading}
                    />

                </Form.Item>

                <Space
                    style={{
                        width: "100%",
                        justifyContent: "flex-end"
                    }}
                >

                    <Button
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>

                    <Button
                        type="primary"
                        htmlType="submit"
                        disabled={loading}
                    >
                        {loading ? <Spin size="small" /> : "Create Department"}
                    </Button>

                </Space>

            </Form>

        </Modal>

    );

};

export default DivisionFormModal;